/**
 * Initializes the sticky CTA component.
 */
export const initStickyCta = () => {
	const getFirstBannerOnPage = () => {
		return document.querySelector('.full-width-hero, .banner');
	}

	const
		footerEl = document.querySelector('footer'),
		stickyCtaEl = document.querySelector('.sticky-cta__wrapper'),
		headerEl = document.querySelector('.header'),
		buttonContainer = document.querySelector('.sticky-cta__button-container'),
		headerOnPage = !!headerEl,
		firstBannerOnPage = getFirstBannerOnPage(),
		hasBannerOnPage = !!firstBannerOnPage;

	let isFooterVisible = false;
	let isBannerVisible = false;
	let isHeaderVisible = false;

	if (!footerEl || !stickyCtaEl) {
		return; // component not required
	}

	/** @type {IntersectionObserverInit} */
	const options = {
		threshold: 0
	};

	// FOOTER INSERSECTION OBSERVER
	/** @type {IntersectionObserverCallback} */
	const handleFooterIntersection = (entries) => {
		// we only care about the last entry if there are multiple
		const lastEntry = entries[entries.length - 1];
		if (!lastEntry)
			return;

		isFooterVisible = lastEntry.isIntersecting;
		processStickyDisplayLogic();
	};

	const footerObserver = new IntersectionObserver(handleFooterIntersection, options);
	footerObserver.observe(footerEl);

	if (hasBannerOnPage) {
		// BANNER INSERSECTION OBSERVER

		/** @type {IntersectionObserverCallback} */
		const handleBannerIntersection = (entries) => {
			// we only care about the first entry if there are multiple
			const firstEntry = entries[0];
			if (!firstEntry)
				return;

			isBannerVisible = firstEntry.isIntersecting;
			processStickyDisplayLogic();
		};

		const bannerObserver = new IntersectionObserver(handleBannerIntersection, options);
		bannerObserver.observe(firstBannerOnPage);
	} else if (headerOnPage) {

		// Fallback to use header intersection observer if no banner on page

		/** @type {IntersectionObserverCallback} */
		const handleHeaderIntersection = (entries) => {
			const firstEntry = entries[0];
			if (!firstEntry)
				return;

			isHeaderVisible = firstEntry.isIntersecting;
			processStickyDisplayLogic();
		};

		const headerObserver = new IntersectionObserver(handleHeaderIntersection, options);
		headerObserver.observe(headerEl);
	}

	// needs a refactor

	const processStickyDisplayLogic = () => {
		if (!footerEl || !stickyCtaEl || !buttonContainer) {
			return;
		}

		const
			ctaBtnEl = buttonContainer.querySelector('.btn'),
			ctaLinkEl = buttonContainer.querySelector('.call-us__link');

		if (isFooterVisible || (hasBannerOnPage && isBannerVisible) || (headerEl && isHeaderVisible)) {
			stickyCtaEl.classList.add('hide');
			// Makes me feel dirty

			if (ctaBtnEl) {
				ctaBtnEl.setAttribute('style', 'display: none !important');
			}

			if (ctaLinkEl) {
				ctaLinkEl.setAttribute('style', 'display: none !important');
			}
		} else {
			stickyCtaEl.classList.remove('hide');

			if (ctaBtnEl) {
				ctaBtnEl.style.display = 'flex';
			}

			if (ctaLinkEl) {
				ctaLinkEl.style.display = 'flex';
			}
		}
	}
};
